import React, { useEffect } from 'react'
import styled from 'styled-components'
import logo from '../../assets/logo.png'
import { Power } from '@styled-icons/fluentui-system-filled/Power'
import { FlxCenter } from '../../styles/globalStyles'
import { EmptyContainer } from '../../styles/globalStyles'
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../MsClient/authConfig"
import { useDispatch } from 'react-redux'
import { b } from '../../styles/variables'
import { useNavigate } from 'react-router-dom'
import { getUserCreds, authenticateUser } from '../../redux/feature/authSlice'

function UserLogin() {
  const { instance, accounts } = useMsal();
  const dispatch = useDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    console.log("accounts: ", accounts);
    if (accounts[0]) {
      try {
        instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0]
        }).then(result => {
          console.log("Login Result", result);
          const userdata = result.account;
          dispatch(getUserCreds(userdata));
          sessionStorage.clear();
          navigate('/', { replace: true });
        }).catch(error => {
          console.log('Token acquisition error:', error);
          console.error(error);
        });
      } catch (error) {
        console.log('SSO redirect error:', error);
      }
    }
  }, [accounts]);

  return (
    <MainContainer>
      <LoginCard>
        <BrandSection>
          <Logo src={logo} />
          <BrandTagline>The Space to Work Effectively</BrandTagline>
        </BrandSection>
        
        <Divider />
        
        <BodySection>
          <StatusRow>
            <StatusDot />
            <StatusText>You are not signed in</StatusText>
          </StatusRow>
          <WelcomeText>Sign in to access the Food App</WelcomeText>
          <LoginButton onClick={() => instance.loginRedirect(loginRequest).catch(e => {
            console.log('SSO login error:', e);
          })}>
            Sign In with Microsoft
          </LoginButton>
        </BodySection>
      </LoginCard>
    </MainContainer>
  )
}

export default UserLogin;

const MainContainer = styled.div`
  height: 100vh;
  height: 100dvh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #f8f9fb 0%, #f0f0f5 100%);
`

const LoginCard = styled.div`
  display: flex;
  flex-direction: column;
  padding: 3.6rem 3.2rem;
  background: white;
  min-width: 380px;
  border-radius: 20px;
  z-index: 1000;
  align-items: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.05);
  
  @media ${b.mobile}{
    min-height: 100%;
    min-width: 100%;
    border-radius: 0;
    justify-content: center;
    padding: 2.4rem;
  }
`

const BrandSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 2rem;
`

const Logo = styled.img`
  width: 180px;
  height: auto;
  margin-bottom: 0.8rem;
`;

const BrandTagline = styled.p`
  font-size: 1.3rem;
  color: #71717a;
  font-weight: 400;
  text-align: center;
`

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: #f4f4f5;
  margin-bottom: 2rem;
`

const BodySection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`

const StatusRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 0.8rem;
`

const StatusDot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #ef4444;
`

const StatusText = styled.span`
  font-size: 1.2rem;
  color: #71717a;
  font-weight: 500;
`

const WelcomeText = styled.p`
  font-size: 1.4rem;
  color: #1e1e2d;
  font-weight: 600;
  margin-bottom: 2rem;
  text-align: center;
`

const LoginButton = styled.button`
  background: linear-gradient(135deg, #F7707D 0%, #F29173 100%);
  border-radius: 12px;
  padding: 1.2rem 2.4rem;
  min-height: 48px;
  width: 100%;
  border: none;
  color: white;
  cursor: pointer;
  font-weight: 700;
  font-size: 1.5rem;
  font-family: 'Nunito Sans', sans-serif;
  transition: all 0.2s ease;
  -webkit-tap-highlight-color: transparent;

  &:hover, &:active {
    transform: translateY(-1px);
    box-shadow: 0 8px 24px rgba(247, 112, 125, 0.3);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 4px 12px rgba(247, 112, 125, 0.2);
  }
`
